
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 140 140"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Layer_2","data-name":"Layer 2"}},[_c('g',{attrs:{"id":"レイヤー_1","data-name":"レイヤー 1"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M56.69 104.17a46.51 46.51 0 01-29.35-18l-.55-.74 35.93-25.2.51.35a3 3 0 001.15.46 3 3 0 003.37-3.64l-.15-.6 35.92-25.15.5.77a46.81 46.81 0 01-47.33 71.75zm6.63-37.5a.46.46 0 00-.53.37l-5.51 31.23a.48.48 0 00.38.54.46.46 0 00.53-.38L63.7 67.2a.47.47 0 00-.38-.53zm6-2.75A.44.44 0 0069 64a.45.45 0 00-.11.64l19 27.2a.45.45 0 00.3.18.43.43 0 00.34-.07.46.46 0 00.12-.64l-19-27.2a.46.46 0 00-.3-.19zm4-4.82a.45.45 0 00-.53.37.46.46 0 00.37.53L105 65.62a.46.46 0 00.16-.9z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M110.48 26.29l-5.86 4.11a48.64 48.64 0 01-79.68 55.79L19.47 90a55.55 55.55 0 1091-63.72z"}}),_c('path',{attrs:{"fill":"none","d":"M0 0h140v140H0z"}})])])])
          )
        }
      }
    